export default "__VITE_ASSET__DJrgqGp7__"